import Layout from '@componentsV2/Layout';

const ErrorPage: React.FC = () => <Layout>TODO: Error Page</Layout>;

export default ErrorPage;
